import React, { useContext, useState } from "react";
import "./CustomPlanCancelPopup.scss";
import ContactForm from "./ContactForm.js"
import AppContext from "../../config/AppContext";
import { useTranslation } from "react-i18next";

const CustomPlanCancelPopup = ({ open, onClose, onConfirm, title, content, email, confirmText, cancelText }) => {
  const { mode } = useContext(AppContext);

  const [isContactForm, setIsContactForm] = useState(false);

  const { t } = useTranslation();

  if (!open) return null;

  return (
    <div className="backdrop">
      <div className={mode === "dark" ? "CustomPlanCancelPopup-containerDark" : "CustomPlanCancelPopup-container"}>
        <span className={mode === "dark" ? "CustomPlanCancelPopup-titleDark" : "CustomPlanCancelPopup-title"}>{title}</span>
        <span className={mode === "dark" ? "horizontal-CustomPlanCancelPopupDark" : "horizontal-CustomPlanCancelPopup"}></span>
        {/* {isContactForm ? (
          <ContactForm onClose={onClose} />
        ) : (<> */}
          <p className={mode === "dark" ? "CustomPlanCancelPopup-contentDark" : "CustomPlanCancelPopup-content"}>
            {content}
          </p>
          <p className={mode === "dark" ? "CustomPlanCancelPopup-emailDark" : "CustomPlanCancelPopup-email"}>{t("RAL0990")}
            {email}
          </p>
          <div className="CustomPlanCancel-buttons">
            {/* <button className={mode === "dark" ? "CustomPlanCancelPopup-buttonDark" : "CustomPlanCancelPopup-button"} onClick={onClose}>
              {cancelText}
            </button> */}
            <button className="CustomPlanConfirmPopup-button" onClick={onConfirm}>
              {confirmText}
            </button>
          </div>
          {/* </>)} */}
      </div>
    </div>
  );
};

export default CustomPlanCancelPopup;
